import OrganizationModel from "src/models/OrganizationModel";
import PrivateSerieModel from "src/models/PrivateSerieModel";
import getUserAge from "src/utils/getUserAge";
import renderEmail from "src/utils/renderEmail";

interface LessonSeriesAddedToEmailInput {
  organization: OrganizationModel;
  privateSerie: PrivateSerieModel;
  numberOfNewLessons: number;
}

const LessonSeriesAddedTo = (vars) => ({
  type: `LessonSeriesAddedTo`,
  subject: `Lesson Series Updated - ${vars.organizationName}`,
  html: `<p>${vars.firstName},</p>

<p>${vars.numberOfNewLessons} additional private lessons with ${vars.studentNamesAndAges} have been purchased. Please visit Captyn at <a href="${vars.organizationUrl}">${vars.organizationUrl}</a> to communicate with the customer and schedule the lessons.</p>

<p>Sincerely,<br />
${vars.organizationName}</p>`,
  sms: `${vars.firstName}, ${vars.numberOfNewLessons} additional private lessons with ${vars.studentNamesAndAges} have been purchased. Please visit Captyn at ${vars.organizationUrl} to schedule.`,
});

export default ({
  organization,
  privateSerie,
  numberOfNewLessons,
}: LessonSeriesAddedToEmailInput) => {
  const template = LessonSeriesAddedTo;

  const studentNames = privateSerie.roster.map((s) => {
    const studentAge = getUserAge(s.birthDate);
    const age = `${studentAge.ageNumber} ${studentAge.ageUnit}`;
    return `${s.firstName} ${s.lastName} (${age})`;
  });

  const variables = {
    organizationName: organization.title,
    firstName: privateSerie.instructor
      ? privateSerie.instructor.firstName
      : organization.title,
    studentNamesAndAges: studentNames.join(", "),
    numberOfNewLessons,
    organizationUrl: `https://${organization.subdomain}.captyn.com/account/lessons`,
  };

  const email = renderEmail({
    template,
    variables,
  });

  return email;
};
